// extracted by mini-css-extract-plugin
export var bg = "Header-module--bg--b1efb";
export var fixed = "Header-module--fixed--39def";
export var header = "Header-module--header--badcc";
export var headerActionLink = "Header-module--headerActionLink--28c31";
export var headerInner = "Header-module--headerInner--1aa7a";
export var headerMobileNav = "Header-module--headerMobileNav--3cb60";
export var headerNavMenu = "Header-module--headerNavMenu--6da4b";